/**
 * Dashboard > Dashboard - 이상 검출 모델 TOP 10 component
 */
import API from '@/views/Fdc/Apis/'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'

export default {
  name: 'DetectionModelRank',
  mounted () {
    this.search()
  },
  methods: {
    /**
     * Chart Data 조회 (이상 검출 모델 TOP 10)
     */
    async search () {
      const payload = {
        // fab: 'BRIQUE'
      }

      await API.Monitor.getDetectionModelTopLank(payload, this.callbackDetectionModelTopLank, [this.$refs.detectionModelRankChart])
    },
    /**
     * Chart Data 조회 callback
     * @param {*} response Chart Data 조회 결과
     */
    callbackDetectionModelTopLank (response) {
      if (response && response.status === 200) {
        this.drawChart(response.data)
      }
    },
    /**
     * Draw Chart
     * @param {*} traces plotly chart data
     */
    drawChart (traces) {
      traces.forEach(trace => {
        trace.type = 'bar'
        trace.orientation = 'h'
        trace.hovertemplate = '%{x:,}<br><b>EQP</b>: %{text.eqp}<br><b>Module</b>: %{text.module}'
      })
      const layout = {
        legend: {
          orientation: 'h',
          y: 1.2
        },
        margin: {
          l: 150
        },
        hovermode: 'y unified'
      }
      const config = {
        responsive: true,
        displayModeBar: false
      }

      BriqueChart.newPlot('detectionModelRankChart', traces, layout, config)
    }
  },
  data () {
    return {
      rowData: [] // chart data
    }
  }
}
